export default {
    items: ["starter"],
}